export * from '@primeuix/themes/lara/image';
export { default } from '@primeuix/themes/lara/image';
